module.exports = __webpack_public_path__ + "static/media/new_fitness_icon.19ca3f23.png";